import { useEffect, useRef } from "react"

const useScrollShadow = ({ direction = "vertical" } = {}) => {
  const scrollContainerRef = useRef(null)
  const startShadowRef = useRef(null)
  const endShadowRef = useRef(null)

  useEffect(() => {
    const container = scrollContainerRef.current
    if (!container) return

    const isHorizontal = direction === "horizontal"

    const updateShadows = () => {
      if (isHorizontal) {
        const { scrollLeft, scrollWidth, clientWidth } = container
        const scrollbarWidth = container.offsetWidth - clientWidth
        const scrollbarHeight = container.offsetHeight - container.clientHeight

        if (startShadowRef.current) {
          startShadowRef.current.style.opacity = scrollLeft > 1 ? "1" : "0"
          startShadowRef.current.style.bottom = `${scrollbarHeight}px`
        }
        if (endShadowRef.current) {
          endShadowRef.current.style.opacity =
            scrollLeft + clientWidth < scrollWidth - 1 ? "1" : "0"
          endShadowRef.current.style.right = `${scrollbarWidth}px`
          endShadowRef.current.style.bottom = `${scrollbarHeight}px`
        }
      } else {
        const { scrollTop, scrollHeight, clientHeight } = container
        const scrollbarWidth = container.offsetWidth - container.clientWidth

        if (startShadowRef.current) {
          startShadowRef.current.style.opacity = scrollTop > 1 ? "1" : "0"
          startShadowRef.current.style.right = `${scrollbarWidth}px`
        }
        if (endShadowRef.current) {
          endShadowRef.current.style.opacity =
            scrollTop + clientHeight < scrollHeight - 1 ? "1" : "0"
          endShadowRef.current.style.right = `${scrollbarWidth}px`
        }
      }
    }

    updateShadows()
    container.addEventListener("scroll", updateShadows, { passive: true })
    window.addEventListener("resize", updateShadows)

    const resizeObserver = new ResizeObserver(updateShadows)
    resizeObserver.observe(container)
    // Also observe direct children so we detect when content grows/shrinks
    // (e.g. DataTableV2 columns toggled — the <table> gets wider but the
    // scroll container itself stays the same size)
    for (const child of container.children) {
      resizeObserver.observe(child)
    }

    return () => {
      container.removeEventListener("scroll", updateShadows)
      window.removeEventListener("resize", updateShadows)
      resizeObserver.disconnect()
    }
  }, [direction])

  return { scrollContainerRef, startShadowRef, endShadowRef }
}

export default useScrollShadow
